import { useCallback, useState } from 'react'

import useDebounce from 'v2/ui/utils/useDebounce'

const DEBOUNCE_TIME = 300 //ms

type UseSectionLongTextAttributeEditorStateProps = {
    value?: string
    onChange: (value: string) => void
}

export function useSectionLongTextAttributeEditorState({
    value,
    onChange,
}: UseSectionLongTextAttributeEditorStateProps) {
    const [localValue, setLocalValue] = useState(value ?? '')
    const debouncedOnChange = useDebounce(onChange, DEBOUNCE_TIME)

    const handleChange = useCallback(
        (e: React.ChangeEvent<HTMLTextAreaElement>) => {
            const newValue = e.target.value
            setLocalValue(newValue)
            debouncedOnChange(newValue)
        },
        [debouncedOnChange]
    )

    return {
        localValue,
        handleChange,
    }
}
